// Classroom mode (display 'screen'): the question is on the stage view, so phones show only the answer marks,
// huge (true or false keeps its check and cross). Tap the culprit shows the test names instead, since a slip can
// have more rows than there are marks. At the reveal the marks show right and wrong and the room's split.
import type { FormatViewProps } from './types';
import { answerState, effectivePhase, sharePct } from './layout';
import { mapSpotRows } from './spotMap';
import { OptionList, useAnswerTap } from './parts';

export function ClassroomMarks(props: FormatViewProps) {
  const { question: q, myOptionId, reveal } = props;
  const phase = effectivePhase(props.phase, myOptionId, reveal);
  const { tap, live } = useAnswerTap({ ...props, phase });
  const revealed = phase === 'revealed' && reveal;
  const hint = <p className="sr-only">The question is on the big screen. Answer here.</p>;

  if (q.format === 'spot' && q.graphic?.type === 'bloods') {
    const rows = q.graphic.rows;
    const { rowOption, unmatched } = mapSpotRows(rows, q.options);
    const items = [
      ...rows.flatMap((r, i) => (rowOption[i] ? [{ id: rowOption[i]!, name: r.test }] : [])),
      ...unmatched.map((o) => ({ id: o.id, name: o.text })),
    ];
    return (
      <div className="fx-format" data-format="spot" data-phase={phase} data-display="screen">
        {hint}
        <div className="fx-spot-marks" role="group" aria-label="Results">
          {items.map((it) => {
            const st = answerState(it.id, phase, myOptionId, reveal);
            return (
              <button key={it.id} type="button" className="fx-spot-mark" data-option={it.id} data-state={st} data-mine={it.id === myOptionId ? '' : undefined}
                aria-pressed={st === 'locked'} disabled={!live} onClick={() => tap(it.id)}>
                {it.name}
                {revealed && <small>{sharePct(reveal, it.id)}%</small>}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="fx-format" data-format={q.format} data-phase={phase} data-display="screen">
      {hint}
      <OptionList options={q.options} format={q.format} phase={phase} myOptionId={myOptionId} reveal={reveal} live={live} onTap={tap} marksOnly />
    </div>
  );
}
